import { Button, Col, Collapse, Divider, Form, Modal, Spin, message } from 'antd'
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import dayjs from 'dayjs';
import { baseUrlAREA, CHECK_CONTNO, HEADERS_BASIC } from '../../../API/apiUrlsGarfe';

function CheckCONTNO({ open, close, data }) {
    const [loading, setLoading] = useState(false);
    const [dataCOTNO, setdataCOTNO] = useState([]);

    useEffect(() => {
        if (data) {
            loadData(data)
        }
    }, [])

    const loadData = async (value) => {
        setLoading(true);
        await axios.get(baseUrlAREA + `${CHECK_CONTNO}/${value}`, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    setdataCOTNO(res.data)
                    setLoading(false);
                    message.success("โหลดข้อมูลสำเร็จ");
                }
            })
            .catch((err) => {
                setLoading(false);
                message.error("โหลดข้อมูลไม่สำเร็จ !! ");
                console.log(err);
            });
    }

    console.log("dataCOTNO", dataCOTNO)

    const handleClose = () => {
        close(false)
    }

    const renderItemContent = (item) => {
        return (
            <Form layout="horizontal" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                <Form.Item label="ชื่อผู้ค้ำ" style={{ marginBottom: 4 }}>
                    <b>{item.customerFullName} ({item.customerTypeId})</b>
                </Form.Item>

                <Form.Item label="EMS ไป" style={{ marginBottom: 4 }}>
                    <span>{item.parcelNo || '-'}</span>
                </Form.Item>

                <Form.Item label="EMS กลับ" style={{ marginBottom: 4 }}>
                    <span>{item.parcelNoResponse || '-'}</span>
                </Form.Item>

                <Form.Item label="รอบ" style={{ marginBottom: 4 }}>
                    <span>{dayjs(item.roundDate).format("DD/MM/YYYY")}</span>
                </Form.Item>

                <Form.Item label="สร้างเมื่อ" style={{ marginBottom: 0 }}>
                    <span>{dayjs(item.createdAt).format("DD/MM/YYYY HH:mm")}</span>
                </Form.Item>
            </Form>
        );
    };

    return (
        <Modal
            open={open}
            // onCancel={handleClose}
            closable={false}
            footer={null}
            title={data}
            width={600}
        >
            <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
                {/* ใช้ items prop สำหรับ Collapse ในเวอร์ชันปัจจุบัน */}
                <Collapse
                    // accordion // ใส่ตัวนี้ถ้าต้องการให้เปิดได้ทีละอัน
                    items={dataCOTNO.map((item, index) => ({
                        key: index,
                        label: (
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '90%' }}>
                                <span><b>
                                    {/* {item.customerFullName}  */}
                                    รอบ {dayjs(item.roundDate).format("DD/MM/YYYY")}</b></span>
                                {/* <span style={{ color: '#888' }}>{item.customerTypeId}</span> */}
                            </div>
                        ),
                        children: renderItemContent(item), // ส่วนเนื้อหาข้างใน
                    }))}
                />
                <Divider />
            </Spin>
            <Col span={24} style={{ textAlign: "end" }}>
                <Button
                    type='primary'
                    danger
                    onClick={handleClose}>
                    ปิด
                </Button>
            </Col>
        </Modal>
    )
}

export default CheckCONTNO